export default __webpack_public_path__ + "static/media/brown.46964cb5.webp";